import { render, staticRenderFns } from "./CardAuthorityEmployees.vue?vue&type=template&id=8dc2969a"
import script from "./CardAuthorityEmployees.vue?vue&type=script&lang=js"
export * from "./CardAuthorityEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports